'use strict';

export default function($stateProvider) {
  'ngInject';
  $stateProvider.state('verdict', {
    url: '/verdict',
    template: '<verdict></verdict>',
  });
}
